//@flow
import React, {useEffect, useMemo, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {
  Grid,
  Typography,
  FormControlLabel,
  Radio,
  InputAdornment,
  Hidden,
  Checkbox,
  Chip,
  Box,
} from '@material-ui/core';
import {Alert} from '@material-ui/lab';
import {getImageUrl} from '../../../../../utils/image_provider';
import {toUTCString, isValidDate} from '../../../../../utils/date';
import CustomTooltip from '../CustomTooltip/CustomTooltip';
//$FlowFixMe
import dayJsUtils from '@date-io/dayjs';
import LoadingSpinner from '../../../../../elements/LoadingSpinner/LoadingSpinner';
import {MuiPickersUtilsProvider} from '@material-ui/pickers';
import {useForm} from 'react-hook-form';
import IosSwitch from '../../../../../elements/IosSwitch/IosSwitch';
import {useHistory, useParams} from 'react-router-dom';
import CustomTextField from '../../../../../elements/CustomTextField/CustomTextField';
import {usePage} from '../../../../page/utils';
import {DeleteOutline} from '@material-ui/icons';
import ModalSelectItems from '../ModalSelectItems/ModalSelectItems';
import CustomButton from '../../../../../elements/CustomButton/CustomButton';
import CustomDatePicker from '../CustomDatePicker/CustomDatePicker';
import SnackBar from '../../../../../elements/SnackBar/SnackBar';
import {commaFormat} from '../../../../../utils/number';

import {colors} from '../../../../../assets/styles/colors';
import Collapsible from '../../../../../elements/Collapsible/Collapsible';
import AlertFeaturedModal from '../AlertFeaturedModal/AlertFeaturedModal';
import AlertCouponAlreadyUsedModal from '../AlertCouponAlreadyUsedModal/AlertCouponAlreadyUsedModal';
import DeleteCouponModal from '../DeleteCouponModal/DeleteCouponModal';
import {useIsFeatureInTier} from '../../../../../utils/component';
import {COUPON_ALREADY_USED_ERROR} from '../../duck';

import type {
  Currency,
  Coupon as CouponEntity,
  CouponType,
  Product,
  Category,
  Pagination,
} from '../../../../../entities';
import type {CouponRequest} from '../../api';
import {APP_BAR_HEIGHT} from '../../../../../layouts/constants';

type Props = {
  coupon?: CouponEntity,
  isFetchingCoupon?: boolean,
  isSaving?: boolean,
  fetchCoupon: ({couponId: string}) => void,
  createCoupon: ({couponRequest: CouponRequest}) => void,
  updateCoupon: ({couponRequest: CouponRequest, couponId: string}) => void,
  error?: string,
  errorCode?: string,
  createCouponSuccess?: boolean,
  updateCouponSuccess?: boolean,
  deleteCouponSuccess?: boolean,
  resetCoupon: () => void,
  currency?: Currency,
  productsFilter?: Product[],
  categoriesFilter?: Category[],
  fetchProducts: ({
    queryFilter?: {[key: string]: string | any},
  }) => void,
  fetchCategoriesSearch: ({
    queryFilter?: {[key: string]: string | any},
  }) => void,
  isFetchingProducts?: boolean,
  isFetchingCategories?: boolean,
  paginationProducts?: Pagination,
  paginationCategories?: Pagination,
  resetProductsFilter: () => void,
  resetCategoriesFilter: () => void,
  coupons?: CouponEntity[],
};

const useStyles = makeStyles(theme => ({
  couponWrap: {},
  gridFormulario: {
    padding: theme.spacing(1),
  },
  checkbox: {
    borderRadius: '8px',
  },
  headerWrapper: {
    width: '100%',
    padding: theme.spacing(0, 0, 2, 0),
    background: '#f8f9fb',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  item: {
    display: 'flex',
    alignItems: 'center',
  },
  headerListItems: {
    background: colors.grey200,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: '12px 12px 0 0',
    padding: '12px',
    marginTop: '16px',
    flexWrap: 'wrap',
    borderBottom: '1px solid #E8E8ED',
  },
  contentList: {
    borderRadius: '12px',
    background: colors.grey100,
  },
  listItemsWrapper: {
    overflow: 'auto',
    padding: '16px',
    maxHeight: '530px',
  },
  deleteItems: {
    color: '#E13065',
    fontWeight: 600,
    fontSize: '12px',
    lineHeight: '16px',
  },
  nameProduct: {
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    display: 'flex',
    alignItems: 'center',
    color: colors.grey800,
    margin: 'auto 8px',
  },
  imageItem: {
    borderRadius: '8px',
  },
  backButton: {
    background: 'white',
    padding: '4px',
    margin: '0 16px 0 0',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
  },
  descriptionWrapper: {
    padding: 0,
    paddingLeft: '24px',
  },
  saveButton: {
    marginBottom: theme.spacing(3),
    borderRadius: '32px',
    [theme.breakpoints.down('sm')]: {
      zIndex: 1,
      position: 'fixed',
      left: 0,
      bottom: `calc(2rem + ${APP_BAR_HEIGHT}px)`,
      margin: theme.spacing(2),
      height: 48,
      width: `calc(100% - ${theme.spacing(4)})`,
      fontSize: '1.125rem',
    },
  },
  title: {
    fontSize: '18px',
    lineHeight: '24px',
    fontWeight: 600,
    color: 'black',
  },
  cardWrap: {
    margin: '16px 0',
    background: '#FFFFFF',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    borderRadius: '12px',
    padding: '24px',
  },
  maxWidth: {
    maxWidth: '600px',
  },
  labelText: {
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '24px',
    color: colors.grey900,
    paddingBottom: '16px',
  },
  commentText: {
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '16px',
    color: colors.grey700,
    padding: '8px 0 24px',
  },
  button: {
    borderRadius: '8px',
    marginTop: '12px',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
  },
  typesWrap: {
    display: 'flex',
    flexDirection: 'column',
  },
  radioButton: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '22px',
    color: colors.grey800,
  },
  radioButtonSelected: {
    fontWeight: 500,
    color: `${colors.grey900} !important`,
  },
  informationLabel: {
    background: '#EEE5FF',
    borderRadius: '8px',
    color: '#7B39FF',
    maxWidth: 196,
    textAlign: 'center',
    padding: 8,
    fontStyle: 'normal',
    fontWeight: 300,
    fontSize: '10px',
    lineHeight: '10px',
    marginTop: '12px',
    marginBottom: '12px',
  },
  textError: {
    color: '#f44336',
    fontSize: '0.75rem',
    marginTop: '3px',
    textAlign: 'left',
    fontWeight: 400,
    lineHeight: '1.66',
  },
  description: {
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0.005em',
    color: colors.grey800,
    marginBottom: '8px',
    padding: 0,
  },
  descriptionTitle: {
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.005em',
    color: colors.grey800,
    marginBottom: '8px',
    padding: 0,
  },
  switch: {
    zoom: 0.8,
    marginLeft: '16px',
  },
  labelSwitch: {},
  switchTitle: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    color: colors.grey800,
  },
  switchBody: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '16px',
    color: colors.grey700,
  },
  radioButtonLabel: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    color: colors.grey800,
  },
  gridContainer: {
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse',
    },
  },
  stickyCard: {
    width: '100%',
    position: 'sticky',
    [theme.breakpoints.down('sm')]: {
      position: 'initial',
      maxWidth: '600px',
    },
  },
  divider: {
    border: '1px solid #E8E8ED',
    color: colors.grey300,
    margin: '16px 0',
  },
  codeCoupon: {
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px',
    color: colors.grey800,
    textTransform: 'uppercase',
    overflowWrap: 'break-word',
  },
  switchContainer: {
    zIndex: 4,
    zoom: 0.8,
    marginLeft: '16px',
  },
  floatingBottom: {
    position: 'absolute',
    bottom: 64,
    left: 0,
    right: 0,
  },
  floatingBottomContent: {
    background: '#FFFFFF',
    height: 'fit-content',
    padding: 32,
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
  },
  archiveButtonWrap: {
    marginTop: '16px',
  },
  archiveButton: {
    color: '#E13065',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  grayText: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    color: '#55556D',
  },
  presetContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    flexDirection: 'column',
    gap: '.5rem',
    marginTop: theme.spacing(1),
  },
  presetLabel: {
    color: colors.grey700,
    fontSize: '14px',
  },
  infoAlert: {
    marginBottom: theme.spacing(2),
    borderRadius: '8px',
  },
}));

export default usePage<Props>(Coupon, 'Coupon');

const PERCENTAGE = 'PERCENTAGE';
const FIXED = 'FIXED';

const DURATION_PRESET = [2, 3, 5, 7, 15, 30];

function Coupon(props: Props) {
  const {
    coupon,
    fetchCoupon,
    isSaving,
    createCouponSuccess,
    updateCouponSuccess,
    isFetchingCoupon,
    createCoupon,
    error,
    errorCode,
    resetCoupon,
    currency,
    updateCoupon,
    productsFilter,
    categoriesFilter,
    fetchProducts,
    fetchCategoriesSearch,
    isFetchingProducts,
    isFetchingCategories,
    paginationProducts,
    paginationCategories,
    resetProductsFilter,
    resetCategoriesFilter,
    coupons,
  } = props;
  const classes = useStyles();
  const history = useHistory();
  const {couponId} = useParams();
  const hasStoreCouponFeature = useIsFeatureInTier('STORE_COUPON');

  const hasFeaturedCoupon = useMemo(() => {
    if (coupons && coupon) {
      return (
        coupons.filter((c: CouponEntity) => c.id !== coupon.id && c.featured)
          .length > 0
      );
    } else return false;
  }, [coupon, coupons]);

  const [couponType, setCouponType] = useState<CouponType | ''>('');
  const [minRequirement, setMinRequirement] = useState('');
  const [errorSubmit, setErrorSubmit] = useState({
    couponType: false,
    minRequirement: false,
  });
  const [activationDate, setActivationDate] = useState(new Date());
  const [expirationDate, setExpirationDate] = useState(new Date());
  const [applyTo, setApplyTo] = useState<
    'ORDER' | 'PRODUCT' | 'PRODUCT_CATEGORY'
  >('ORDER');
  const [openModal, setOpenModal] = useState(false);
  const [listProductsItems, setListProductsItems] = useState([]);
  const [listCategoryItems, setListCategoryItems] = useState([]);
  const [listItems, setListItems] = useState([]);
  const [listToDelete, setListToDelete] = useState([]);

  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const [firstPurchaseActive, setFirstPurchaseActive] = useState(false);

  useEffect(() => {
    if (coupon) {
      setActivationDate(new Date(coupon.activationDate));
      setExpirationDate(new Date(coupon.expirationDate));
      setCouponType(coupon.couponType);
      setApplyTo(
        coupon.couponConstraints.couponScopeSettings
          ? coupon.couponConstraints.couponScopeSettings.scope
          : 'ORDER'
      );

      let minRequirement = 'none';

      if (coupon.couponConstraints.orderItemsQuantity) {
        minRequirement = 'minProducts';
      }
      if (coupon.couponConstraints.orderItemsAmount) {
        minRequirement = 'minAmount';
      }
      if (coupon.couponConstraints.firstPurchase) {
        setFirstPurchaseActive(true);
      }

      setMinRequirement(minRequirement);
      if (coupon.couponConstraints.couponScopeSettings) {
        const settings = coupon.couponConstraints.couponScopeSettings;
        setListItems(
          settings && settings.couponProducts
            ? // $FlowFixMe
              settings.couponProducts.map(i => ({
                id: i.id,
                name: i.name,
                mainImageId: i.image_id,
              }))
            : settings && settings.couponProductCategories
            ? settings.couponProductCategories.map(i => ({
                id: i.id,
                name: i.name,
                portraitImageId: i.image_id,
              }))
            : []
        );
      }
    }
  }, [coupon]);

  useEffect(() => () => resetCoupon(), [resetCoupon]);

  useEffect(() => {
    if (couponId && couponId !== 'new') fetchCoupon({couponId});
  }, [couponId, fetchCoupon]);

  const {handleSubmit, watch, register, errors} = useForm();
  const watchDiscountValue = watch('discountValue', 0);
  const watchAllValues = watch();

  useEffect(() => {
    if (couponType === FIXED) setMinRequirement('minAmount');
  }, [couponType]);

  const [openModalFeaturedCoupon, setOpenModalFeaturedCoupon] = useState(false);

  const onSubmit = values => {
    const {
      discountCode,
      discountValue,
      minAmount,
      minProducts,
      usageLimit,
      applyToSalePrice,
      couponFeatured,
    } = values;
    if (!couponType || !minRequirement) {
      setErrorSubmit({
        minRequirement: !Boolean(couponType),
        couponType: !Boolean(minRequirement),
      });
    } else {
      setErrorSubmit({
        minRequirement: false,
        couponType: false,
      });
      const actDate = new Date(activationDate);
      const expDate = new Date(expirationDate);
      if (!coupon) {
        const data = {
          code: discountCode,
          couponType: couponType,
          discount:
            couponType === PERCENTAGE
              ? (Number(discountValue) / 100).toString()
              : discountValue,
          activationDate: toUTCString(actDate),
          expirationDate: toUTCString(expDate, true),
          featured:
            typeof couponFeatured === 'boolean' ? couponFeatured : false,
          couponConstraints: {
            orderItemsAmount: minAmount,
            orderItemsQuantity: minProducts ? Number(minProducts) : undefined,
            dontApplyOnOfferPrices: !applyToSalePrice,
            usageLimit: Number(usageLimit),
            firstPurchase: firstPurchaseActive,
            couponScopeSettings: {
              scope: applyTo,
              products:
                applyTo === 'PRODUCT' ? listItems.map(i => i.id) : undefined,
              productCategories:
                applyTo === 'PRODUCT_CATEGORY'
                  ? listItems.map(i => i.id)
                  : undefined,
            },
          },
        };

        createCoupon({
          couponRequest: data,
        });
      } else {
        // After creation, only usage limit and expiration date remain editable.
        const data = {
          expirationDate: toUTCString(expDate, true),
          couponConstraints: {
            usageLimit: Number(usageLimit),
          },
          featured:
            typeof couponFeatured === 'boolean' ? couponFeatured : false,
        };

        updateCoupon({
          couponRequest: data,
          couponId: coupon.id,
        });
      }
    }
  };

  const handleChangeDate = (date?: Date, type: string) => {
    if (date) {
      if (type === 'start') setActivationDate(date);
      else setExpirationDate(date);
    }
  };

  useEffect(() => {
    if (
      !Boolean(error) &&
      (createCouponSuccess || updateCouponSuccess) &&
      coupon
    ) {
      history.push(`/marketing/coupons`);
    }
  }, [coupon, createCouponSuccess, error, history, updateCouponSuccess]);

  const handleAddToDeleteItem = (e, index: number) => {
    const posItem: number = listToDelete.findIndex(
      i => listItems && i.id === listItems[index].id
    );

    const newList = [...listToDelete];
    if (e.target.checked) {
      if (posItem === -1) newList.push({...listItems[index], checked: true});
    } else {
      if (posItem > -1) newList.splice(posItem, 1);
    }

    setListToDelete(newList);
  };

  const handleModalDelete = () => {
    setOpenDeleteModal(true);
  };

  const handleDeleteCoupon = () => {
    if (coupon) {
      updateCoupon({
        couponRequest: {archived: true},
        couponId: coupon.id,
      });
    }
  };

  const handleChangeFeaturedCoupon = (featured: boolean) => {
    if (coupon) {
      updateCoupon({
        couponRequest: {featured},
        couponId: coupon.id,
      });
    }
  };

  const activationDateFormatted = useMemo(() => {
    if (!isValidDate(activationDate)) {
      return '';
    }
    const formattedDate = new Intl.DateTimeFormat('es-PE', {
      day: '2-digit',
      month: '2-digit',
      year: '2-digit',
    }).format(activationDate);

    return formattedDate;
  }, [activationDate]);

  const expirationDateFormatted = useMemo(() => {
    if (!isValidDate(expirationDate)) {
      return '';
    }

    const formattedDate = new Intl.DateTimeFormat('es-PE', {
      day: '2-digit',
      month: '2-digit',
      year: '2-digit',
    }).format(expirationDate);

    return formattedDate;
  }, [expirationDate]);

  const diffDays = useMemo(() => {
    if (
      !activationDate ||
      !expirationDate ||
      !(activationDate instanceof Date) ||
      !(expirationDate instanceof Date)
    )
      return 0;
    const diffTime = expirationDate.getTime() - activationDate.getTime();
    return Math.round(diffTime / (1000 * 3600 * 24));
  }, [activationDate, expirationDate]);

  const remainingDays = useMemo(() => {
    if (!expirationDate || !(expirationDate instanceof Date)) return 0;
    const now = new Date();
    const diffTime = expirationDate.getTime() - now.getTime();
    return Math.ceil(diffTime / (1000 * 3600 * 24));
  }, [expirationDate]);

  const isLocked = coupon && !coupon.enabled;
  const isEditMode = Boolean(coupon && coupon.id);
  // After a coupon is created, most fields become read-only.
  const areFieldsLocked = isEditMode;
  const [couponUsedAlertOpen, setCouponUsedAlertOpen] = useState(false);

  useEffect(() => {
    if (errorCode === COUPON_ALREADY_USED_ERROR) {
      setCouponUsedAlertOpen(true);
    }
  }, [errorCode]);

  return (
    <div className={classes.couponWrap}>
      {(isSaving ||
        isFetchingCoupon ||
        !currency ||
        (!coupon && couponId !== 'new')) && <LoadingSpinner />}
      <SnackBar
        mode="error"
        className={classes.snackBarError}
        message={errorCode === COUPON_ALREADY_USED_ERROR ? undefined : error}
      />
      <AlertCouponAlreadyUsedModal
        open={couponUsedAlertOpen}
        handleClose={() => setCouponUsedAlertOpen(false)}
        message={error}
      />

      <Grid container alignContent="flex-start">
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          className={classes.gridFormulario}
        >
          <div className={classes.headerWrapper}>
            <div>
              <Typography className={classes.grayText}>
                Los cupones se podrán aplicar al pedido si se cumplen las
                condiciones.
                <br />
              </Typography>
            </div>
          </div>
          {!isEditMode && (
            <Alert severity="info" className={classes.infoAlert}>
              Después de crear el cupón, la mayoría de los campos no se podrán
              editar. Solo podrás modificar el <strong>límite de usos</strong> y
              la <strong>fecha de expiración</strong>.
            </Alert>
          )}
          {areFieldsLocked && (
            <Alert severity="warning" className={classes.infoAlert}>
              Algunos campos no se pueden editar porque este cupón ya fue
              utilizado en un pedido. Solo puedes modificar el{' '}
              <strong>límite de usos</strong> y la{' '}
              <strong>fecha de expiración</strong>.
            </Alert>
          )}
          <Grid container spacing={2} className={classes.gridContainer}>
            {!isSaving &&
              !isFetchingCoupon &&
              (coupon || couponId === 'new') &&
              currency && (
                <>
                  <Grid item xs={12} sm={12} md={8} lg={8}>
                    <form noValidate>
                      <div className={classes.cardWrap}>
                        <div>
                          <Typography className={classes.labelText}>
                            Código de descuento
                          </Typography>
                          <CustomTextField
                            fullWidth
                            placeholder="Nombre del cupón"
                            name="discountCode"
                            inputRef={register({
                              required: 'Campo obligatorio',
                              maxLength: {
                                value: 18,
                                message: 'Máximo de 18 caractéres',
                              },
                              pattern: {
                                value: /^[a-zA-Z0-9]*$/i,
                                message:
                                  'Nombre de cupón inválido: Caracteres no permitidos ñ y caracteres especiales (%$#)',
                              },
                            })}
                            InputProps={{
                              readOnly: !!coupon,
                            }}
                            inputProps={{
                              style: {textTransform: 'uppercase'},
                            }}
                            defaultValue={coupon ? coupon.code : ''}
                            error={!!errors.discountCode}
                            helperText={
                              errors.discountCode
                                ? errors.discountCode.message
                                : ''
                            }
                          />
                          <Typography className={classes.commentText}>
                            Los usuarios usarán este cupón al momento de pagar.
                            El nombre del cupón no puede contener espacios, ñ,
                            ni caractéres especiales (%$#) y debe tener máx 18
                            caractéres.
                          </Typography>
                        </div>
                        <div className={classes.typesWrap}>
                          <Typography className={classes.labelText}>
                            Tipos de cupón
                          </Typography>
                          <FormControlLabel
                            value={couponType}
                            control={
                              <Radio
                                checked={couponType === PERCENTAGE}
                                size="small"
                                color="primary"
                                onChange={() => setCouponType(PERCENTAGE)}
                                disabled={areFieldsLocked}
                              />
                            }
                            label={
                              <span
                                className={`${
                                  couponType === PERCENTAGE
                                    ? classes.radioButtonSelected
                                    : classes.radioButtonLabel
                                }`}
                              >
                                Porcentaje
                              </span>
                            }
                          />
                          <FormControlLabel
                            value={couponType}
                            control={
                              <Radio
                                checked={couponType === FIXED}
                                size="small"
                                color="primary"
                                onChange={() => {
                                  setCouponType(FIXED);
                                  setApplyTo('ORDER');
                                }}
                                disabled={areFieldsLocked}
                              />
                            }
                            label={
                              <span
                                className={`${
                                  couponType === FIXED
                                    ? classes.radioButtonSelected
                                    : classes.radioButtonLabel
                                }`}
                              >
                                Monto Fijo
                              </span>
                            }
                          />

                          {errorSubmit.couponType && !couponType && (
                            <span className={classes.textError}>
                              Debe seleccionar un tipo de cupón
                            </span>
                          )}
                        </div>
                        <br />
                        <div>
                          <Typography className={classes.labelText}>
                            Valor de descuento
                          </Typography>
                          <CustomTextField
                            placeholder={
                              couponType === FIXED ? `${currency.symbol}0` : ''
                            }
                            fullWidth
                            name="discountValue"
                            defaultValue={
                              coupon && coupon.discountFixed
                                ? coupon.discountFixed
                                : coupon && coupon.discountPercentage
                                ? (
                                    Number(coupon.discountPercentage) * 100
                                  ).toFixed(0)
                                : ''
                            }
                            inputRef={register({
                              required: 'Campo obligatorio',
                              pattern: {
                                value:
                                  couponType === PERCENTAGE
                                    ? /^[1-9][0-9]?$|^100$/
                                    : /^[0-9]+([.][0-9]+)?$/i,
                                message:
                                  couponType === PERCENTAGE
                                    ? 'Ingresar un numero entre 1 y 100'
                                    : 'Formato de número inválido',
                              },
                            })}
                            InputProps={{
                              readOnly: areFieldsLocked,
                              endAdornment: couponType === PERCENTAGE && (
                                <InputAdornment
                                  position="end"
                                  style={{
                                    marginTop: '0',
                                    position: 'absolute',
                                    marginLeft: '94%',
                                  }}
                                >
                                  %
                                </InputAdornment>
                              ),
                            }}
                            error={!!errors.discountValue}
                            helperText={
                              errors.discountValue
                                ? errors.discountValue.message
                                : ''
                            }
                          />
                        </div>
                        <br />
                        <div>
                          <FormControlLabel
                            control={
                              <IosSwitch
                                className={classes.switchContainer}
                                name="applyToSalePrice"
                                inputRef={register()}
                                color="primary"
                                defaultChecked={
                                  coupon
                                    ? !coupon.couponConstraints
                                        .dontApplyOnOfferPrices
                                    : false
                                }
                                disabled={areFieldsLocked}
                              />
                            }
                            label={
                              <div className={classes.description}>
                                <Typography
                                  className={classes.descriptionTitle}
                                >
                                  ¿Aplica sobre precios de oferta?
                                </Typography>
                                <Typography className={classes.description}>
                                  Si desactivas esta opción, el cupón aplicará
                                  sobre el precio regular del producto.
                                </Typography>
                              </div>
                            }
                          />
                        </div>
                      </div>
                      <div className={classes.cardWrap}>
                        <div className={classes.typesWrap}>
                          <Typography className={classes.labelText}>
                            Aplica a
                          </Typography>
                          <FormControlLabel
                            value={minRequirement}
                            control={
                              <Radio
                                size="small"
                                color="primary"
                                checked={applyTo === 'ORDER'}
                                onChange={() => setApplyTo('ORDER')}
                                disabled={areFieldsLocked}
                              />
                            }
                            label={
                              <span
                                className={`${
                                  applyTo === 'ORDER'
                                    ? classes.radioButtonSelected
                                    : classes.radioButtonLabel
                                }`}
                              >
                                Toda la orden
                              </span>
                            }
                          />
                          {couponType !== FIXED && (
                            <>
                              <FormControlLabel
                                value={minRequirement}
                                control={
                                  <Radio
                                    size="small"
                                    color="primary"
                                    checked={applyTo === 'PRODUCT'}
                                    onChange={() => {
                                      setListCategoryItems(listItems);
                                      setListItems(listProductsItems);
                                      setApplyTo('PRODUCT');
                                    }}
                                    disabled={areFieldsLocked}
                                  />
                                }
                                label={
                                  <span
                                    className={`${
                                      applyTo === 'PRODUCT'
                                        ? classes.radioButtonSelected
                                        : classes.radioButtonLabel
                                    }`}
                                  >
                                    Productos específicos
                                  </span>
                                }
                              />
                              <FormControlLabel
                                value={minRequirement}
                                control={
                                  <Radio
                                    size="small"
                                    color="primary"
                                    checked={applyTo === 'PRODUCT_CATEGORY'}
                                    onChange={() => {
                                      setListProductsItems(listItems);
                                      setListItems(listCategoryItems);
                                      setApplyTo('PRODUCT_CATEGORY');
                                    }}
                                    disabled={areFieldsLocked}
                                  />
                                }
                                label={
                                  <span
                                    className={`${
                                      applyTo === 'PRODUCT_CATEGORY'
                                        ? classes.radioButtonSelected
                                        : classes.radioButtonLabel
                                    }`}
                                  >
                                    Categorías específicas
                                  </span>
                                }
                              />
                            </>
                          )}
                          {(applyTo === 'PRODUCT' ||
                            applyTo === 'PRODUCT_CATEGORY') && (
                            <CustomButton
                              fullWidth
                              variant="outlined"
                              color="primary"
                              size="large"
                              className={classes.button}
                              disabled={areFieldsLocked}
                              onClick={() => setOpenModal(true)}
                            >
                              {`${
                                listItems.length > 0
                                  ? 'Agregar más '
                                  : 'Seleccionar '
                              } ${
                                applyTo === 'PRODUCT'
                                  ? 'productos'
                                  : 'categorías'
                              }`}
                            </CustomButton>
                          )}
                          {listItems.length > 0 &&
                            (applyTo === 'PRODUCT' ||
                              applyTo === 'PRODUCT_CATEGORY') && (
                              <div className={classes.contentList}>
                                <div className={classes.headerListItems}>
                                  <FormControlLabel
                                    classes={{label: classes.item}}
                                    className={classes.option}
                                    control={
                                      <Checkbox
                                        color="primary"
                                        className={classes.checkbox}
                                        checked={
                                          listToDelete.length ===
                                          listItems.length
                                        }
                                        disabled={areFieldsLocked}
                                        onChange={e => {
                                          const isChecked = e.target.checked;
                                          if (isChecked) {
                                            setListToDelete(listItems);
                                          } else setListToDelete([]);
                                        }}
                                      />
                                    }
                                    label={`${
                                      applyTo === 'PRODUCT'
                                        ? 'Productos'
                                        : 'Categorías'
                                    } (${listToDelete.length})`}
                                  />
                                  {listToDelete.length === 0 ? (
                                    <div
                                      style={{
                                        color: '#E13065',
                                        fontSize: '12px',
                                        fontWeight: 600,
                                        lineHeight: '16px',
                                      }}
                                    >
                                      {`Seleccionar  ${
                                        applyTo === 'PRODUCT'
                                          ? 'los productos'
                                          : 'las categorías'
                                      } que desea eliminar`}
                                    </div>
                                  ) : (
                                    <CustomButton
                                      className={classes.deleteItems}
                                      disabled={areFieldsLocked}
                                      onClick={() => {
                                        const list = listItems.filter(i => {
                                          const pos = listToDelete.find(
                                            d => d.id === i.id
                                          );
                                          return !pos;
                                        });
                                        setListToDelete([]);
                                        setListItems(list);
                                      }}
                                    >
                                      {listToDelete.length === listItems.length
                                        ? 'Eliminar todos'
                                        : 'Eliminar seleccionados'}
                                    </CustomButton>
                                  )}
                                </div>
                                <Grid
                                  container
                                  spacing={2}
                                  className={classes.listItemsWrapper}
                                >
                                  {listItems.map((p, index: number) => (
                                    <Grid
                                      container
                                      item
                                      xs={12}
                                      sm={12}
                                      md={12}
                                      lg={12}
                                      key={index}
                                      className={classes.item}
                                    >
                                      <div
                                        key={index}
                                        className={classes.wrapperItem}
                                      >
                                        <FormControlLabel
                                          classes={{label: classes.item}}
                                          className={classes.option}
                                          control={
                                            <Checkbox
                                              color="primary"
                                              className={classes.checkbox}
                                              checked={
                                                !!listToDelete.find(
                                                  l => l.id === p.id
                                                )
                                              }
                                              disabled={areFieldsLocked}
                                              onChange={e =>
                                                handleAddToDeleteItem(e, index)
                                              }
                                            />
                                          }
                                          label={
                                            <div className={classes.item}>
                                              <div
                                                style={{
                                                  display: 'flex',
                                                  alignItems: 'center',
                                                }}
                                              >
                                                <img
                                                  className={classes.imageItem}
                                                  alt={p.name}
                                                  src={getImageUrl(
                                                    p.mainImageId ||
                                                      p.portraitImageId
                                                  )}
                                                  width="56"
                                                  height="56"
                                                />

                                                <div
                                                  className={
                                                    classes.nameProduct
                                                  }
                                                >
                                                  {p.name}
                                                </div>
                                              </div>
                                            </div>
                                          }
                                        />
                                      </div>
                                    </Grid>
                                  ))}
                                </Grid>
                              </div>
                            )}
                        </div>
                      </div>
                      <div className={classes.cardWrap}>
                        <div className={classes.typesWrap}>
                          <Typography className={classes.labelText}>
                            Requerimiento Mínimo
                          </Typography>
                          <div style={{display: 'flex'}}>
                            <CustomTooltip
                              title="No disponible bajo la configuración de monto fijo."
                              isToolTip={couponType === FIXED}
                            >
                              <FormControlLabel
                                value={minRequirement}
                                control={
                                  <Radio
                                    size="small"
                                    color="primary"
                                    checked={minRequirement === 'none'}
                                    onChange={() => setMinRequirement('none')}
                                    disabled={
                                      areFieldsLocked || couponType === FIXED
                                    }
                                  />
                                }
                                label={
                                  <span
                                    className={`${
                                      minRequirement === 'none'
                                        ? classes.radioButtonSelected
                                        : classes.radioButtonLabel
                                    }`}
                                    style={{textTransform: 'capitalize'}}
                                  >
                                    Ninguno
                                  </span>
                                }
                              />
                            </CustomTooltip>
                          </div>

                          <FormControlLabel
                            value={minRequirement}
                            control={
                              <Radio
                                size="small"
                                color="primary"
                                checked={minRequirement === 'minAmount'}
                                onChange={() => setMinRequirement('minAmount')}
                                disabled={areFieldsLocked}
                              />
                            }
                            label={
                              <span
                                className={`${
                                  minRequirement === 'minAmount'
                                    ? classes.radioButtonSelected
                                    : classes.radioButtonLabel
                                }`}
                              >
                                {`Compra mínima de (${currency.symbol})`}
                              </span>
                            }
                          />
                          {minRequirement === 'minAmount' && (
                            <CustomTextField
                              placeholder={currency.symbol}
                              fullWidth
                              type="number"
                              name="minAmount"
                              inputRef={register({
                                required: 'Campo obligatorio',
                                pattern: {
                                  value: /^[0-9]+([.][0-9]+)?$/i,
                                  message: 'Formato de número inválido',
                                },
                                min: {
                                  value:
                                    couponType === FIXED
                                      ? Number(watchDiscountValue)
                                      : 0,
                                  message:
                                    couponType === FIXED
                                      ? 'Monto mínimo de compra debe ser mayor al valor de descuento.'
                                      : 'Monto no puede ser menor a 0',
                                },
                              })}
                              defaultValue={
                                (coupon &&
                                  coupon.couponConstraints.orderItemsAmount) ||
                                ''
                              }
                              InputProps={{
                                readOnly: areFieldsLocked,
                              }}
                              error={!!errors.minAmount}
                              helperText={
                                errors.minAmount ? errors.minAmount.message : ''
                              }
                            />
                          )}
                          <div style={{display: 'flex'}}>
                            <CustomTooltip
                              title="No disponible bajo la configuración de monto fijo."
                              isToolTip={couponType === FIXED}
                            >
                              <FormControlLabel
                                value={minRequirement}
                                control={
                                  <Radio
                                    size="small"
                                    color="primary"
                                    checked={minRequirement === 'minProducts'}
                                    onChange={() =>
                                      setMinRequirement('minProducts')
                                    }
                                    disabled={
                                      areFieldsLocked || couponType === FIXED
                                    }
                                  />
                                }
                                label={
                                  <span
                                    className={`${
                                      minRequirement === 'minProducts'
                                        ? classes.radioButtonSelected
                                        : classes.radioButtonLabel
                                    }`}
                                    style={{textTransform: 'capitalize'}}
                                  >
                                    Cantidad mínima de productos
                                  </span>
                                }
                              />
                            </CustomTooltip>
                          </div>
                          {minRequirement === 'minProducts' && (
                            <CustomTextField
                              fullWidth
                              name="minProducts"
                              inputRef={register({
                                required: 'Campo obligatorio',
                                pattern: {
                                  value: /^[0-9]*$/i,
                                  message: 'Formato de número inválido',
                                },
                                min: {
                                  value: 1,
                                  message:
                                    'Cantidad de productos no puede ser menor a 0',
                                },
                              })}
                              InputProps={{
                                readOnly: areFieldsLocked,
                              }}
                              defaultValue={
                                (coupon &&
                                  coupon.couponConstraints
                                    .orderItemsQuantity) ||
                                ''
                              }
                              error={!!errors.minProducts}
                              helperText={
                                errors.minProducts
                                  ? errors.minProducts.message
                                  : ''
                              }
                            />
                          )}
                          {errorSubmit.minRequirement && !minRequirement && (
                            <span className={classes.textError}>
                              Debe seleccionar un requerimiento mínimo
                            </span>
                          )}
                        </div>
                      </div>
                      <div className={classes.cardWrap}>
                        <div className={classes.typesWrap}>
                          <Typography className={classes.labelText}>
                            Límite de usos
                          </Typography>
                          <div>
                            <span
                              className={classes.radioButtonLabel}
                              style={{
                                marginBottom: '.5rem',
                                display: 'block',
                              }}
                            >
                              Limitar número de veces que el cupón se puede usar
                              en su totalidad
                            </span>

                            <Grid container spacing={2}>
                              <Grid item xs={12} sm={12} md={12} lg={12}>
                                <CustomTextField
                                  placeholder="Cantidad máxima de usos"
                                  fullWidth
                                  name="usageLimit"
                                  inputRef={register({
                                    required: 'Campo obligatorio',
                                    pattern: {
                                      value: /^[0-9]+([.][0-9]+)?$/i,
                                      message: 'Formato de número inválido',
                                    },
                                    // validate: {
                                    //   minValue: value => {
                                    //     if (
                                    //       coupon &&
                                    //       coupon.couponConstraints
                                    //     ) {
                                    //       return (
                                    //         parseInt(value) >=
                                    //         (coupon.couponConstraints
                                    //           .usageLimit || 0)
                                    //       );
                                    //     } else return parseInt(value) >= 0;
                                    //   },
                                    // },
                                  })}
                                  defaultValue={
                                    coupon
                                      ? coupon.couponConstraints.usageLimit
                                      : ''
                                  }
                                  error={!!errors.usageLimit}
                                  helperText={
                                    errors.usageLimit
                                      ? errors.usageLimit.message ||
                                        `La cantidad de usos tiene que ser mayor a ${
                                          coupon && coupon.couponConstraints
                                            ? coupon.couponConstraints
                                                .usageLimit || 0
                                            : 0
                                        }`
                                      : ''
                                  }
                                />
                              </Grid>
                              <Grid item xs={12} sm={12} md={12} lg={12}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      color="primary"
                                      checked={firstPurchaseActive}
                                      disabled={areFieldsLocked}
                                      onChange={() =>
                                        setFirstPurchaseActive(prev => !prev)
                                      }
                                    />
                                  }
                                  label={
                                    <Typography className={classes.nameEstado}>
                                      Cupón válido solo para la primera compra
                                    </Typography>
                                  }
                                />
                              </Grid>
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={12}
                                style={{
                                  paddingTop: 0,
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                <div className={classes.switchBody}>
                                  Cuando llegue a esta cantidad, el cupón dejará
                                  de funcionar.
                                </div>
                              </Grid>
                            </Grid>
                          </div>
                        </div>
                      </div>
                      <div className={classes.cardWrap}>
                        <MuiPickersUtilsProvider utils={dayJsUtils}>
                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={12}>
                              <Typography
                                className={classes.labelText}
                                style={{
                                  padding: 0,
                                }}
                              >
                                Fechas de uso
                              </Typography>
                              <div className={classes.presetContainer}>
                                {isEditMode && (
                                  <Box
                                    display="flex"
                                    alignItems="center"
                                    style={{gap: '.5rem'}}
                                  >
                                    <Typography className={classes.presetLabel}>
                                      Tiempo restante:
                                    </Typography>
                                    <Chip
                                      label={
                                        remainingDays > 0
                                          ? `${remainingDays} días`
                                          : 'Expirado'
                                      }
                                      className={classes.chip}
                                      variant="default"
                                      size="small"
                                      color={
                                        remainingDays > 0
                                          ? 'primary'
                                          : 'default'
                                      }
                                      style={{marginRight: '16px'}}
                                    />
                                  </Box>
                                )}

                                {!isLocked && (
                                  <Box
                                    display="flex"
                                    alignItems="center"
                                    style={{gap: '.5rem', flexWrap: 'wrap'}}
                                  >
                                    <Typography className={classes.presetLabel}>
                                      {isEditMode
                                        ? 'Extender fecha:'
                                        : 'Duración sugerida:'}
                                    </Typography>
                                    {DURATION_PRESET.map(days => (
                                      <Chip
                                        key={days}
                                        label={
                                          isEditMode
                                            ? `+${days} días`
                                            : `${days} días`
                                        }
                                        onClick={() => {
                                          const baseDate = isEditMode
                                            ? expirationDate
                                            : activationDate;
                                          const newDate = new Date(baseDate);
                                          newDate.setDate(
                                            newDate.getDate() + days
                                          );
                                          setExpirationDate(newDate);
                                        }}
                                        className={classes.chip}
                                        variant={
                                          !isEditMode && diffDays === days
                                            ? 'default'
                                            : 'outlined'
                                        }
                                        size="small"
                                        color="primary"
                                        clickable
                                      />
                                    ))}
                                  </Box>
                                )}
                              </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <CustomDatePicker
                                disabled={areFieldsLocked}
                                label="Fecha de activación"
                                handleChange={date =>
                                  handleChangeDate(date, 'start')
                                }
                                value={activationDate}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <CustomDatePicker
                                label="Fecha de expiración"
                                handleChange={date =>
                                  handleChangeDate(date, 'end')
                                }
                                value={expirationDate}
                                minDate={activationDate}
                                minDateMessage={
                                  'Fecha no puede ser anterior a la fecha de activación'
                                }
                              />
                            </Grid>
                          </Grid>
                        </MuiPickersUtilsProvider>
                      </div>
                    </form>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={4}
                    lg={4}
                    style={{position: 'relative'}}
                  >
                    <Hidden mdUp>
                      <Collapsible
                        startClosed
                        className={classes.maxWidth}
                        title={
                          <div>
                            <div>Resumen de cupón</div>
                            {watchAllValues.discountCode && (
                              <div className={classes.codeCoupon}>
                                <span>{watchAllValues.discountCode}</span>
                              </div>
                            )}
                          </div>
                        }
                      >
                        <ul className={classes.descriptionWrapper}>
                          {couponType === PERCENTAGE &&
                            !isNaN(watchAllValues.discountValue) && (
                              <li className={classes.description}>
                                <span>{`${Number(
                                  watchAllValues.discountValue
                                ).toString()}% de descuento en toda la orden`}</span>
                              </li>
                            )}
                          {couponType === FIXED && currency && (
                            <li className={classes.description}>
                              <span>{`${commaFormat(
                                watchAllValues.discountValue,
                                currency.symbol
                              )} de descuento en toda la orden`}</span>
                            </li>
                          )}
                          {/* {watchAllValues.discountValue && (
                          <li className={classes.description}>
                            <span>{`Límite de ${watchAllValues.discountValue} cupones, un cupón por persona`}</span>
                          </li>
                        )}
                      */}
                          {minRequirement === 'minAmount' &&
                            watchAllValues.minAmount &&
                            currency && (
                              <li className={classes.description}>
                                <span>{`Descuento aplicado por compras mayor a ${commaFormat(
                                  watchAllValues.minAmount,
                                  currency.symbol
                                )}`}</span>
                              </li>
                            )}
                          {minRequirement === 'minProducts' &&
                            watchAllValues.minProducts && (
                              <li className={classes.description}>
                                <span>{`Descuento aplicado por la compra de más de ${watchAllValues.minProducts} productos`}</span>
                              </li>
                            )}
                          {activationDate && (
                            <li className={classes.description}>
                              <span>
                                {`Activo desde: ${activationDateFormatted}`}
                              </span>
                            </li>
                          )}
                          {expirationDate && (
                            <li className={classes.description}>
                              <span>{`Activo hasta: ${expirationDateFormatted}`}</span>
                            </li>
                          )}
                        </ul>

                        <span>
                          <FormControlLabel
                            control={
                              <IosSwitch
                                className={classes.switchContainer}
                                name="couponFeatured"
                                onChange={e => {
                                  if (e.target.checked && hasFeaturedCoupon) {
                                    setOpenModalFeaturedCoupon(true);
                                  } else {
                                    handleChangeFeaturedCoupon(false);
                                    setOpenModalFeaturedCoupon(false);
                                  }
                                }}
                                inputRef={register()}
                                color="primary"
                                defaultChecked={coupon && coupon.featured}
                                disabled={!hasStoreCouponFeature}
                              />
                            }
                            label={
                              <div className={classes.descriptionTitle}>
                                Mostrar en la tienda
                              </div>
                            }
                          />
                        </span>
                        <div className={classes.switchBody}>
                          Se mostrará en la parte superior de tu tienda.
                        </div>

                        {coupon && hasStoreCouponFeature && (
                          <div className={classes.archiveButtonWrap}>
                            <CustomButton
                              className={classes.archiveButton}
                              onClick={handleModalDelete}
                              fullWidth
                              startIcon={<DeleteOutline />}
                            >
                              Eliminar cupón
                            </CustomButton>
                          </div>
                        )}
                      </Collapsible>
                    </Hidden>

                    <Hidden smDown>
                      <div
                        className={`${classes.maxWidth} ${classes.stickyCard} `}
                      >
                        <div className={classes.cardWrap}>
                          <div>
                            <Typography
                              className={classes.labelText}
                              style={{padding: 0, margin: 0}}
                            >
                              Resumen de cupón
                            </Typography>
                            <hr className={classes.divider} />
                            <div>
                              {watchAllValues.discountCode && (
                                <div className={classes.codeCoupon}>
                                  <span>{watchAllValues.discountCode}</span>
                                </div>
                              )}
                              <ul className={classes.descriptionWrapper}>
                                {couponType === PERCENTAGE && (
                                  <li className={classes.description}>
                                    <span>{`${Number(
                                      watchAllValues.discountValue
                                    ).toString()}% de descuento en toda la orden`}</span>
                                  </li>
                                )}
                                {couponType === FIXED && currency && (
                                  <li className={classes.description}>
                                    <span>{`${commaFormat(
                                      watchAllValues.discountValue,
                                      currency.symbol
                                    )} de descuento en toda la orden`}</span>
                                  </li>
                                )}
                                {minRequirement === 'minAmount' &&
                                  watchAllValues.minAmount &&
                                  currency && (
                                    <li className={classes.description}>
                                      <span>{`Descuento aplicado por compras mayor a ${commaFormat(
                                        watchAllValues.minAmount,
                                        currency.symbol
                                      )}`}</span>
                                    </li>
                                  )}
                                {minRequirement === 'minProducts' &&
                                  watchAllValues.minProducts && (
                                    <li className={classes.description}>
                                      <span>{`Descuento aplicado por la compra de más de ${watchAllValues.minProducts} productos`}</span>
                                    </li>
                                  )}
                                {activationDate && (
                                  <li className={classes.description}>
                                    <span>
                                      {`Activo desde: ${activationDateFormatted}`}
                                    </span>
                                  </li>
                                )}
                                {expirationDate && (
                                  <li className={classes.description}>
                                    <span>{`Activo hasta: ${expirationDateFormatted}`}</span>
                                  </li>
                                )}
                              </ul>

                              <span>
                                <FormControlLabel
                                  control={
                                    <IosSwitch
                                      className={classes.switchContainer}
                                      name="couponFeatured"
                                      inputRef={register()}
                                      onChange={e => {
                                        if (
                                          e.target.checked &&
                                          hasFeaturedCoupon
                                        ) {
                                          setOpenModalFeaturedCoupon(true);
                                        } else {
                                          handleChangeFeaturedCoupon(false);
                                          setOpenModalFeaturedCoupon(false);
                                        }
                                      }}
                                      color="primary"
                                      defaultChecked={coupon && coupon.featured}
                                      disabled={!hasStoreCouponFeature}
                                    />
                                  }
                                  label={
                                    <div className={classes.descriptionTitle}>
                                      Mostrar en la tienda
                                    </div>
                                  }
                                />
                              </span>
                              <div className={classes.switchBody}>
                                Se mostrará en la parte superior de tu tienda.
                              </div>
                            </div>
                          </div>
                        </div>
                        {hasStoreCouponFeature && (
                          <Hidden smDown>
                            <div
                              className={classes.cardWrap}
                              style={{padding: '16px'}}
                            >
                              <CustomButton
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="primary"
                                size="large"
                                className={classes.saveButton}
                                disabled={isSaving}
                                style={{margin: 0}}
                                onClick={handleSubmit(onSubmit)}
                              >
                                {coupon ? 'Guardar cambios' : 'Crear cupón'}
                              </CustomButton>
                            </div>
                            {coupon && hasStoreCouponFeature && (
                              <CustomButton
                                className={classes.archiveButton}
                                onClick={handleModalDelete}
                                fullWidth
                                startIcon={<DeleteOutline />}
                              >
                                Eliminar cupón
                              </CustomButton>
                            )}
                          </Hidden>
                        )}
                      </div>
                    </Hidden>
                  </Grid>
                </>
              )}
          </Grid>
        </Grid>
      </Grid>
      <DeleteCouponModal
        isSaving={isSaving}
        open={openDeleteModal}
        handleClose={() => setOpenDeleteModal(false)}
        handleDeleteCoupon={handleDeleteCoupon}
      />
      <AlertFeaturedModal
        openModal={openModalFeaturedCoupon}
        handleCloseModal={() => setOpenModalFeaturedCoupon(false)}
        handleFeaturedCoupon={() => {
          handleChangeFeaturedCoupon(true);
          setOpenModal(false);
        }}
      />
      {openModal && (
        <ModalSelectItems
          title={
            applyTo === 'PRODUCT' ? 'Agregar productos' : 'Agregar categorías'
          }
          open={openModal}
          handleClose={() => setOpenModal(false)}
          items={applyTo === 'PRODUCT' ? productsFilter : categoriesFilter}
          type={applyTo === 'PRODUCT' ? 'PRODUCT' : 'PRODUCT_CATEGORY'}
          pagination={
            applyTo === 'PRODUCT' ? paginationProducts : paginationCategories
          }
          isFetchingItems={
            applyTo === 'PRODUCT' ? isFetchingProducts : isFetchingCategories
          }
          fetchCategories={fetchCategoriesSearch}
          fetchProducts={fetchProducts}
          setListItems={value => {
            setListItems(value);
            if (applyTo === 'PRODUCT') setListProductsItems(value);
            else setListCategoryItems(value);
          }}
          listItems={listItems}
          resetListFilter={
            applyTo === 'PRODUCT' ? resetProductsFilter : resetCategoriesFilter
          }
        />
      )}

      {hasStoreCouponFeature && (
        <Hidden mdUp>
          <div className={classes.floatingBottom}>
            <div className={classes.floatingBottomContent}>
              <CustomButton
                type="submit"
                variant="contained"
                color="primary"
                size="large"
                className={classes.saveButton}
                disabled={isSaving}
                style={{margin: '0 16px'}}
                onClick={handleSubmit(onSubmit)}
              >
                {coupon ? 'Guardar cambios' : 'Crear cupón'}
              </CustomButton>
            </div>
          </div>
        </Hidden>
      )}
    </div>
  );
}
